/**
 * @generated SignedSource<<7dc2709af374fe1a831546542a2bf4bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactSellerButton_refactor_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
  readonly " $fragmentType": "PdpSharedContactSellerButton_refactor_item";
};
export type PdpSharedContactSellerButton_refactor_item$key = {
  readonly " $data"?: PdpSharedContactSellerButton_refactor_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_refactor_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactSellerButton_refactor_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "9d89cccd2adcadfc3a5a512d0cdc94aa";

export default node;
